import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { DataNotFound } from '../../../../components/DataNotFound';
import { getAsync, postAsync } from '../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../shared/Helper';
import InfiniteScroll from 'react-infinite-scroll-component';
import BannerImg from '../../../../../public/assets/images/BannersFiles/31.jpg';
import Loader from '../../../../components/Loader/Loader';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import PpCmsFilter from '../../../../components/elements/PpCmsFilter';
import StaticBanner from '../../../../components/elements/StaticBanner';
import moment from 'moment';
import './videoGallery.scss';

export default function VideoGallery() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [apiDataById, setApiDataById] = useState([]);
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [datanotfound, setDatanotfound] = useState(false);
  const [sortOrder, setSortOrder] = useState(0);
  const [date, setDate] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [searchTitle, setSearchTitle] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 6,
  });
  const toggleShowCreate = () => setGridModalcreate(!gridModalcreate);

  const { t } = useTranslation();
  const { pathname } = useLocation();

  const SearchFilter = {
    cmsTitle: searchTitle,
    dateFrom: moment(date).format('DD/MM/YYYY') ?? '',
    dateTo: moment(date).format('DD/MM/YYYY') || '',
  };

  useEffect(() => {
    PageHitCountApi(pathname, 0);
    localStorage.setItem('isHome', pathname != '/VideoGallery' ? false : true);
    getData();
  }, []);

  const getById = async (e, id) => {
    toggleShowCreate();
    e.preventDefault();
    await getAsync('CMSVideoGallery/GetByIdCMSVideoGallery/' + id)
      .then((response) => {
        const result = response?.data?.data;
        setApiDataById(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getData = async () => {
    setLoading(true);
    await postAsync(
      `CMSVideoGallery/GetCMSVideoGallerySortFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
      SearchFilter,
    )
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
        setLoading(false);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchData = async () => {
    const newPage = pageOptions.pageNo + 1;

    try {
      setPageOptions((prev) => {
        return {
          ...prev,
          pageNo: prev.pageNo + 1,
        };
      });
      const response = await postAsync(
        `CMSVideoGallery/GetCMSVideoGallerySortFilterList/${newPage}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      const newData = response?.data || [];
      setApiData((prevData) => [...prevData, ...newData]);
      setCurrentPage(response.currentPage);
    } catch (error) {
      console.error('Error fetching data:', error);
      setHasMore(false);
    }
  };


  const onSearch = async () => {
    try {
      setLoading(true);
      setDatanotfound(false);
      setPageOptions((pre) => {
        return {
          ...pre,
          pageNo: 1,
        };
      });
      const response = await postAsync(
        `CMSVideoGallery/GetCMSVideoGallerySortFilterList/${1}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      if (response) {
        setLoading(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="">
        <StaticBanner BannerImg={BannerImg} en_US={'Video Gallery'} />;<br></br>
        <section className="px-4">
          <div className="py-4">
            <PpCmsFilter setSortOrder={setSortOrder} date={date} setDate={setDate} getData={onSearch} setSearchTitle={setSearchTitle} />
          </div>
          {apiData?.length > 0 && (
            <div>
              {!loading && apiData?.length > 0 && (
                <InfiniteScroll
                  className="row justify-center"
                  dataLength={apiData?.length}
                  next={currentPage === pageCount ? <></> : fetchData}
                  hasMore={hasMore}
                  loader={
                    currentPage === pageCount ? (
                      <></>
                    ) : (
                      <div className="flex justify-center">
                        <Loader />
                      </div>
                    )
                  }
                >
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4  ">
                    {apiData.map((data, index) => (
                      // eslint-disable-next-line react/jsx-key
                      <div data-aos="zoom-in" data-aos-once="true" key={index} className="aspect-w-16 h-32  sm:h-56">
                        <iframe className="w-full h-full" src={data?.link} allowFullScreen></iframe>
                      </div>
                    ))}
                  </div>
                </InfiniteScroll>
              )}
            </div>
          )}
          {loading && <LoadingAnimation />}
          {datanotfound && <DataNotFound />}
        </section>
        <br></br>
      </div>
    </>
  );
}
